/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { CheckIcon } from '@heroicons/react/solid'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Anchor, Badge, Card, Theme } from '@nexigendigital/nxui'
import { Weight } from 'models/enums'
import { useAppSelector } from 'store/hooks'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Complete() {
    const navigate = useNavigate()
    const { order } = useAppSelector((state) => state.shop)

    return (
        <OrderCompleteWrapper>
            <Card
                footer={
                    <Anchor color={'primary'} onClick={() => navigate('/shop')}>
                        Back to Shop
                    </Anchor>
                }
            >
                <Order>
                    <Icon><CheckIcon/></Icon>
                    <Heading>
                        <h1>Order Complete</h1>
                        <h2>
                            <span>Order Number</span>
                            <Badge color={'primary'}>{order?.id}</Badge>
                        </h2>
                    </Heading>
                    <Message>
                        You will receive a confirmation email with you order details shortly.
                        Your newly purchased domains and services can be managed in the Domains and Services pages
                        respectively.
                    </Message>
                </Order>
            </Card>
        </OrderCompleteWrapper>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const OrderCompleteWrapper = styled.article`
    min-width: 420px;

    ${props => (Theme.Functions.mediaBreakDown(props.theme['breakpoints-sm']))} {
        min-width: initial;
        width: 100%;
    }

    footer {
        height: 62px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props => props.theme['background--100']};
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
    }
`

const Order = styled.article`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 17px;
    text-align: center;
`

const Icon = styled.div`
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #e3fcf1;

    > svg {
        fill: #008055;
        width: 20px;
        height: 20px;
    }
`

const Heading = styled.div`
    display: grid;
    gap: 8px;

    > h1 {
        font-size: 1.125rem;
        ${Theme.Functions.setFont('Inter', Weight.Medium)};
        color: ${props => props.theme['text--300']};
    }

    h2 {
        font-size: .875rem;
        display: flex;
        align-items: center;
        gap: 8px;
        color: ${props => props.theme['text--100']};
    }
`

const Message = styled.p`
    color: ${props => props.theme['text--100']};
`
